
import { Component, Mixins } from 'vue-property-decorator';
import DeviceData from '~/components/Data.vue';
import DatadogLinks from '~/components/Device/DatadogLinks.vue';
import DeviceGroup from '~/components/Device/DeviceGroup.vue';
import Device from '~/components/Device/index.vue';
import Operations from '~/components/Device/Operations.vue';
import Secret from '~/components/Device/Secret.vue';
import { Device as IDevice, Operation } from '~/interfaces/device.interface';
import { FieldObject } from '~/interfaces/field.interface';
import UserRightsMixin from '~/mixins/UserRightsMixin';
import { DevicesModule } from '~/store/modules/devices';

@Component({
    components: {
        Device,
        DeviceData,
        Secret,
        DatadogLinks,
        DeviceGroup,
        Operations,
    },
})
export default class Gateway extends Mixins(UserRightsMixin) {
    get currentGatewayId(): string {
        return DevicesModule.currentGatewayId;
    }

    get currentGateway(): IDevice | undefined {
        return DevicesModule.currentGateway;
    }

    get specsData(): FieldObject[] | undefined {
        return this.currentGateway?.orderedSpecFields;
    }

    get isSecretShown(): boolean {
        return Boolean(this.currentGateway && this.isAllowed(this.currentGateway.type, 'readSecret'));
    }

    get networkData(): FieldObject[] |undefined {
        return this.currentGateway?.getNetworkFields();
    }

    get modulesCount(): { key: string, value: number }[] {
        const { wiredCount, wirelessCount } = DevicesModule.currentGatewayModuleCount;
        return [
            { key: 'totalCount', value: wiredCount + wirelessCount },
            { key: 'wiredCount', value: wiredCount },
            { key: 'wirelessCount', value: wirelessCount },
        ];
    }

    get monkeyData(): FieldObject[] | null | undefined {
        return this.currentGateway?.monkeyFields;
    }
    get nexelecData(): FieldObject[] | null | undefined {
        return this.currentGateway?.nexelecFields;
    }
    get nsdData(): FieldObject[] | null | undefined {
        return this.currentGateway?.NSDFields;
    }
    get ncoData(): FieldObject[] | null | undefined {
        return this.currentGateway?.NCOFields;
    }
    get settingsData(): FieldObject[] | null | undefined {
        return this.currentGateway?.settingsFields;
    }
    get powerBoardData(): FieldObject[] | null | undefined {
        return this.currentGateway?.powerBoardFields;
    }

    get filteredOperations(): Operation[] {
        const currentGateway = this.currentGateway;
        if (!currentGateway) {
            return [];
        }
        return currentGateway.deviceOperations
            .filter((operation) => {
                return this.isAllowed(currentGateway.type, operation.action) && !operation.hidden;
            });
    }

    get showOperations(): boolean {
        return this.filteredOperations.length > 0;
    }
}
